module.exports = __webpack_public_path__ + "img/logobai.741284f1.png";